import React from "react";
import styles from "./styles.m.css";

const SubscribeBanner = () => {
  return (
    <div className={styles["subscribe-banner-wrapper"]}>
      <a
        href="https://www.vikatan.com/store?utm_source=direct_web&utm_medium=web_page&utm_campaign=ad_unit&appredirect=website"
        target="_blank"
        rel="noopener noreferrer"
        className={styles["subscribe-banner-link"]}
      >
        Tired of Ads? <span>Subscribe Now</span>
      </a>
    </div>
  );
};

export default SubscribeBanner;
